import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_ebc17ae8/layouts/default.vue").then(m => m.default || m)),
  noauth: defineAsyncComponent(() => import("/tmp/build_ebc17ae8/layouts/noauth.vue").then(m => m.default || m))
}